export default __webpack_public_path__ + "static/media/oasis.5c0449c0.webp";